import { SearchSeriesData, SeriesWarningEnum } from '../../../store/series/types';
import { WarningCounts } from '../types';

export function countWarnings(searchData: SearchSeriesData): WarningCounts {
  const counts: WarningCounts = {
    missingOutcome: 0,
    missingFollowup: 0,
    ratioExceeded: 0,
  };

  for (let orderIndex = 0; orderIndex < searchData.order.length; orderIndex += 1) {
    const row = searchData.byId[searchData.order[orderIndex]];

    if (row !== undefined) {
      for (let warningIndex = 0; warningIndex < row.warnings.length; warningIndex += 1) {
        const warning = row.warnings[warningIndex];

        if (warning === SeriesWarningEnum.OUTCOME_MISSING) {
          counts.missingOutcome += 1;
        }
        if (warning === SeriesWarningEnum.FOLLOWUP_MISSING) {
          counts.missingFollowup += 1;
        }
        if (warning === SeriesWarningEnum.RATIO_EXCEEDED) {
          counts.ratioExceeded += 1;
        }
      }
    }
  }

  return counts;
}
